import React from 'react'
import { Paper, PaperContent } from '@e3dc-react/shell/Elements/Paper'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Grid } from '@mui/material'
import GraphicBaseCard from 'src/Libs/graph-cards/components/GraphicBaseCard'
import { PowerMeterModel } from 'src/Libs/power-meters'
import { MeasurementBoundaries } from 'src/Libs/api'
import { UnitTypes } from 'src/Libs/types'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'

interface Props {
  model?: PowerMeterModel
  powerLevelL1: number[]
  powerLevelL2: number[]
  powerLevelL3: number[]
}

/*
 * Renders power meter overview
 */
const PowerMeterOverview: React.FC<Props> = ({ model, powerLevelL1, powerLevelL3, powerLevelL2 }) => {
  const { t } = useCustomTranslation()

  return (
    <Paper title={t('systemSettings.powerMeter.overview.sectionTitle')}>
      <PaperContent>
        {model ? (
          <PowerMeterGraphs model={model} powerLevelL1={powerLevelL1} powerLevelL2={powerLevelL2} powerLevelL3={powerLevelL3} />
        ) : (
          <SystemSettingsBlankView />
        )}
      </PaperContent>
    </Paper>
  )
}

export default PowerMeterOverview

/*
 * Renders power meter overview graphs
 */
const PowerMeterGraphs: React.FC<{
  model: PowerMeterModel
  powerLevelL1: number[]
  powerLevelL2: number[]
  powerLevelL3: number[]
}> = ({ model, powerLevelL1, powerLevelL3, powerLevelL2 }) => {
  const { t } = useCustomTranslation()

  const powerLevels = [
    { ...model.powerL1, values: powerLevelL1 },
    { ...model.powerL2, values: powerLevelL2 },
    { ...model.powerL3, values: powerLevelL3 },
  ] as MeasurementBoundaries[]

  const chartTags = (value: number): string => {
    return `${value.toString()} ${UnitTypes.watt}`
  }

  return (
    <Grid container direction="row" justifyContent="space-between" spacing={3} sx={{ pt: 3, pb: 3 }}>
      {powerLevels.map((boundaries, index) => (
        <Grid key={index} item xs={12} sm={4}>
          <GraphicBaseCard
            key={index}
            values={boundaries.values}
            tagLabel={chartTags}
            min={boundaries.min}
            max={boundaries.max}
            title={t(`systemSettings.powerMeter.overview.powerL${index + 1}`)}
            titlePosition={'top'}
            subtitle={`${(model.energy[index] || 0).toFixed(2)} ${UnitTypes.kiloWattHour}`}
            unit={UnitTypes.watt}
          />
        </Grid>
      ))}
    </Grid>
  )
}
